<div class="edit-container" *ngIf="!isLoading">
  <!-- Header Section -->
  <div class="header-section">
    <div class="header-left">
      <button class="btn-back" (click)="goBack()">
        ← Back to List
      </button>
      <h1 class="page-title">Edit Survey</h1>
    </div>
    <div class="header-right">
      <button class="btn-cancel" (click)="onCancel()" [disabled]="isSaving">
        Cancel
      </button>
      <button class="btn-save" (click)="onSubmit()" [disabled]="isSaving">
        <span *ngIf="!isSaving">💾 Save Changes</span>
        <span *ngIf="isSaving">Saving...</span>
      </button>
    </div>
  </div>

  <!-- Main Form -->
  <div class="form-container">
    <!-- Basic Information Card -->
    <div class="form-card">
      <h3 class="card-title">Basic Information</h3>
      
      <div class="form-group">
        <label class="form-label required">Survey Title</label>
        <input 
          type="text" 
          class="form-input" 
          [(ngModel)]="surveyData.survey_title"
          placeholder="Enter survey title"
        />
      </div>

      <div class="form-group">
        <label class="form-label required">Survey Description</label>
        <textarea 
          class="form-textarea" 
          [(ngModel)]="surveyData.survey_description"
          placeholder="Enter survey description"
          rows="3"
        ></textarea>
      </div>

      <!-- <div class="form-group">
        <label class="form-label">Survey ID</label>
        <input 
          type="text" 
          class="form-input" 
          [value]="surveyData.survey_id"
          disabled
        />
      </div> -->
    </div>

    <!-- Question Sets Section -->
    <div class="question-sets-section">
      <div class="section-header">
        <h3 class="section-title">Question Sets</h3>
        <button class="btn-add-set" (click)="addQuestionSet()">
          ➕ Add Question Set
        </button>
      </div>

      <!-- Question Sets List -->
      <div class="question-sets-list">
        <div 
          class="question-set-card" 
          *ngFor="let set of surveyData.questionnaire_sets; let setIndex = index"
        >
          <!-- Set Header -->
          <div class="set-header">
            <div class="set-header-left">
              <span class="set-badge">{{ set.set_id }}</span>
              <input 
                type="text" 
                class="set-name-input" 
                [(ngModel)]="set.set_name"
                placeholder="Enter set name"
              />
            </div>
            <div class="set-header-right">
              <span class="question-count">{{ set.questions.length }} questions</span>
              <button 
                class="btn-icon btn-remove" 
                (click)="removeQuestionSet(setIndex)"
                title="Remove Question Set"
              >
                🗑️
              </button>
            </div>
          </div>

          <!-- Questions in Set -->
          <div class="questions-list">
            <div 
              class="question-card" 
              *ngFor="let question of set.questions; let qIndex = index"
            >
              <!-- Question Header -->
              <div class="question-header-row">
                <span class="question-number">Q{{ qIndex + 1 }}</span>
                <input 
                  type="text" 
                  class="question-id-input" 
                  [(ngModel)]="question.question_id"
                  placeholder="Question ID"
                />
                <button 
                  class="btn-icon btn-remove-question" 
                  (click)="removeQuestion(setIndex, qIndex)"
                  title="Remove Question"
                >
                  ✖
                </button>
              </div>

              <!-- Question Text -->
              <div class="form-group">
                <label class="form-label required">Question Text</label>
                <input 
                  type="text" 
                  class="form-input" 
                  [(ngModel)]="question.question_text"
                  placeholder="Enter your question here"
                />
              </div>

              <!-- Question Type and Required -->
              <div class="question-settings">
                <div class="form-group flex-1">
                  <label class="form-label">Question Type</label>
                  <select 
                    class="form-select" 
                    [(ngModel)]="question.question_type"
                    (change)="onQuestionTypeChange(setIndex, qIndex)"
                  >
                    <option *ngFor="let type of questionTypes" [value]="type.value">
                      {{ type.label }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label class="form-label">Required</label>
                  <div class="checkbox-wrapper">
                    <input 
                      type="checkbox" 
                      class="form-checkbox" 
                      [(ngModel)]="question.is_required"
                      [id]="'required-' + setIndex + '-' + qIndex"
                    />
                    <label [for]="'required-' + setIndex + '-' + qIndex" class="checkbox-label">
                      This question is required
                    </label>
                  </div>
                </div>
              </div>

              <!-- Options for Multiple Choice -->
              <div class="options-section" *ngIf="question.question_type === 'multiple_choice'">
                <div class="options-header">
                  <label class="form-label">Answer Options</label>
                  <button 
                    class="btn-add-option" 
                    (click)="addOption(setIndex, qIndex)"
                  >
                    ➕ Add Option
                  </button>
                </div>

                <div class="options-list">
                  <div 
                    class="option-item" 
                    *ngFor="let option of question.options; let optIndex = index"
                  >
                    <span class="option-number">{{ optIndex + 1 }}.</span>
                    <input 
                      type="text" 
                      class="option-input" 
                      [value]="option"
                      (input)="trackOption(setIndex, qIndex, optIndex, $any($event.target).value)"
                      placeholder="Enter option text"
                    />
                    <button 
                      class="btn-icon btn-remove-option" 
                      (click)="removeOption(setIndex, qIndex, optIndex)"
                      *ngIf="question.options && question.options.length > 1"
                      title="Remove Option"
                    >
                      ✖
                    </button>
                  </div>
                </div>
              </div>

              <!-- Info for other question types -->
              <div class="question-type-info" *ngIf="question.question_type === 'star_rating'">
                <i class="info-icon">ℹ️</i>
                <span>Respondents will rate this question on a scale of 1-5 stars</span>
              </div>

              <div class="question-type-info" *ngIf="question.question_type === 'text'">
                <i class="info-icon">ℹ️</i>
                <span>Respondents will provide a text answer to this question</span>
              </div>
            </div>

            <!-- Add Question Button -->
            <button 
              class="btn-add-question" 
              (click)="addQuestion(setIndex)"
            >
              ➕ Add Question to {{ set.set_name }}
            </button>
          </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="surveyData.questionnaire_sets.length === 0">
          <div class="empty-icon">📋</div>
          <p class="empty-text">No question sets added yet</p>
          <p class="empty-subtext">Click "Add Question Set" to get started</p>
        </div>
      </div>
    </div>

    <!-- Action Buttons (Bottom) -->
    <div class="form-actions">
      <button class="btn-cancel-bottom" (click)="onCancel()" [disabled]="isSaving">
        Cancel
      </button>
      <button class="btn-save-bottom" (click)="onSubmit()" [disabled]="isSaving">
        <span *ngIf="!isSaving">💾 Save Changes</span>
        <span *ngIf="isSaving">
          <span class="spinner-small"></span> Saving...
        </span>
      </button>
    </div>
  </div>
</div>

<!-- Loading State -->
<div class="loading-container" *ngIf="isLoading">
  <div class="spinner"></div>
  <p>Loading survey data...</p>
</div>